import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import resizeImageFileForUpload from '../../../../../../../../../helpers/resizeImageFileForUpload';
import styles from '../BasicSettings.module.css';
import useLazyQuery from '../../../../../../../../../surveys/hooks/useLazyQuery';
import { GET_MEDIA_UPLOAD_SAS } from '../../../../../../../../../graphql/Survey';
import close from '../../../../../../../../../assets/img/close-white.svg';

const DropZoneText = ({ isDragActive, uploading }) => {
  if (uploading) {
    return (
      <div className={styles.dropContainer}>
        Uploading image, please wait...
      </div>
    );
  }

  if (isDragActive) {
    return (
      <div className={styles.dropContainer}>Drop the image file here...</div>
    );
  }

  return (
    <div className={styles.dropContainer}>
      <div className={styles.button}>Select a file</div>
      <div className={styles.dropDescription}>or drag and drop file here</div>
    </div>
  );
};

export default ({
  title,
  internalPostLanguageData,
  setInternalPostLanguageData,
  activeLanguageTab,
  propertyField,
  propertyFieldFullPath
}) => {
  const [uploading, setUploading] = useState(false);
  const [sessionUploads, setSessionUploads] = useState({});

  const getMediaUploadSAS = useLazyQuery(GET_MEDIA_UPLOAD_SAS);

  const onImageSelect = async acceptedFiles => {
    setUploading(true);

    const origFilename = acceptedFiles[0].name;

    const {
      data: { mediaUploadSAS: { uri: sasURI, filename } = {} } = {}
    } = await getMediaUploadSAS({
      variables: {
        fileName: origFilename
      }
    });

    if (!sasURI) {
      return;
    }

    const xhr = new XMLHttpRequest();

    xhr.onload = () => {
      if (xhr.status === 201) {
        setInternalPostLanguageData(propertyField, filename);

        const baseImageUrl = sasURI.split('?')[0];
        setSessionUploads({
          ...sessionUploads,
          [activeLanguageTab]: baseImageUrl
        });

        setUploading(false);
      }
    };

    xhr.open('PUT', sasURI, true);
    xhr.setRequestHeader('Content-Type', 'image/jpeg');
    xhr.setRequestHeader('x-ms-blob-type', 'BlockBlob');

    try {
      const imageToUpload = await resizeImageFileForUpload(acceptedFiles[0]);
      xhr.send(imageToUpload);
    } catch (err) {
      console.log(err);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/jpg, image/jpeg, image/png',
    multiple: false,
    onDrop: onImageSelect
  });

  return (
    <>
      <div className={styles.subtitle}>
        {title}
        <span className={styles.requiredAsterisk}>*</span>
      </div>
      {internalPostLanguageData && internalPostLanguageData[propertyField] ? (
        <div className={styles.imageContainer}>
          <img
            className={styles.coverImage}
            alt="Cover"
            src={
              sessionUploads[activeLanguageTab] ||
              internalPostLanguageData[propertyFieldFullPath]
            }
          />
          <div
            className={styles.removeImageContainer}
            role="presentation"
            onClick={() => {
              setInternalPostLanguageData(propertyField, null);

              const newSessionUploads = { ...sessionUploads };
              delete newSessionUploads[activeLanguageTab];
              setSessionUploads(newSessionUploads);
            }}
          >
            <img alt="Close" src={close} />
          </div>
        </div>
      ) : (
        <div className={styles.dropZone}>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <DropZoneText
              isDragActive={isDragActive}
              pdfCoupons={[]}
              uploading={uploading}
            />
          </div>
        </div>
      )}
    </>
  );
};
